<template>
    <div class="body-panel dataContent">
        <template v-if="task != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                        </p>
                        <p class="caption-help margin-right-10" v-if="task.new">Создание нового задания</p>
                        <p class="caption-help" v-if="!task.new">Редактирование задания #{{ task.Id }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <button type="button" class="btn btn-primary" @click="copyTasksSettingsModal()" v-if="!task.new">Дублировать задание</button>
                        <button type="button" class="btn btn-primary" @click="saveTasks()" v-if="allowEdit">Сохранить</button>
                        <button type="button" class="btn btn-delete" @click="deleteTasks" v-if="!task.new && allowEdit">Удалить</button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="body-panel">
                    <div class="block-in-page closed">
                        <h2 class="margin-bottom-20 block-in-page-collapce">Общее</h2>
                        <div class="block-in-page-detail">
                            <div class="line-separator margin-bottom-15 margin-top-15"></div>
                            <div class="form-field-group mob-inline">
                                <div class="form-field">
                                    <div>
                                        <label class="input-text-lbl">
                                            Название
                                            <span class="required" aria-required="true">*</span>
                                        </label>
                                        <input maxlength="256" type="text"
                                               :name="'SettingsName'"
                                               :class="['input-text', {'input-error': errors.has('SettingsName')}]"
                                               v-model="task.Name"
                                               v-validate="'required'"
                                               :disabled="!allowEdit"
                                               data-vv-as="Название" />
                                        <span class="field-validation-valid">{{ errors.first('SettingsName') }}</span>
                                    </div>
                                    <div class="margin-top-5">
                                        <label class="input-text-lbl">
                                            Название кнопки добавления ответа
                                            <span class="required" aria-required="true">*</span>
                                        </label>
                                        <input maxlength="256" type="text"
                                               :name="'AnswerBtnAddText'"
                                               :class="['input-text', {'input-error': errors.has('AnswerBtnAddText')}]"
                                               v-model="task.VisualSettings.AnswerBtnAddText"
                                               v-validate="'required'"
                                               :disabled="!allowEdit"
                                               data-vv-as="Название кнопки добавления ответа" />
                                        <span class="field-validation-valid">{{ errors.first('AnswerBtnAddText') }}</span>
                                    </div>
                                </div>
                                <div class="form-field">
                                    <div>
                                        <label class="input-text-lbl">
                                            Дата начала
                                            <span class="required" aria-required="true">*</span>
                                        </label>
                                        <div class="input-date-lbl">
                                            <input-date name="StartDateFormatted"
                                                        v-validate="'required'"
                                                        v-model="task.StartDateFormatted"
                                                        :disabled="!allowEdit"
                                                        @input="onChangeDate(task, 'StartDateFormatted', 'StartDate')"
                                                        :class="['input-text', {'input-error': errors.has('StartDateFormatted')}]"
                                                        todayHighlight="true"
                                                        data-vv-as="Дата начала"></input-date>
                                        </div>
                                        <span class="field-validation-valid">{{ errors.first('StartDateFormatted') }}</span>
                                    </div>
                                    <div style="margin-top:2px">
                                        <label class="input-text-lbl">
                                            Дата окончания
                                            <span class="required" aria-required="true">*</span>
                                        </label>
                                        <div class="input-date-lbl">
                                            <input-date name="EndDateFormatted"
                                                        v-validate="'required'"
                                                        v-model="task.EndDateFormatted"
                                                        :disabled="!allowEdit"
                                                        @input="onChangeDate(task, 'EndDateFormatted', 'EndDate')"
                                                        :class="['input-text', {'input-error': errors.has('EndDateFormatted')}]"
                                                        todayHighlight="true"
                                                        data-vv-as="Дата окончания"></input-date>
                                        </div>
                                        <span class="field-validation-valid">{{ errors.first('EndDateFormatted') }}</span>
                                    </div>
                                    <div class="margin-top-3">
                                        <label class="input-text-lbl">Тип задания</label>
                                        <drop-down :items="taskTypeItems"
                                                   :dataField="'Value'"
                                                   :textField="'Name'"
                                                   :disabled="!allowEdit"
                                                   v-model="task.TaskType"
                                                   @change="onTaskTypeChange()"></drop-down>
                                    </div>
                                </div>
                                <div class="form-field with-upload-zone">
                                    <label class="input-text-lbl">Вложения</label>
                                    <div class="flex" style="flex-wrap:wrap">
                                        <div :class="['', {'thumbnail-img-file' : !item.isImage}, {'task-photo thumbnail-img' : item.isImage}]" v-for="(item, i) of task.TasksAttachments">
                                            <template v-if="!item.isImage">
                                                <svg class="tasks-svg svg-icon" v-if="item.TypeId==='docx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <use xlink:href="/Content/dist/image_svg.svg?v2#Docx" />
                                                </svg>
                                                <svg class="tasks-svg svg-icon" v-if="item.TypeId==='xlsx'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <use xlink:href="/Content/dist/image_svg.svg?v2#Xlsx" />
                                                </svg>
                                                <svg class="tasks-svg svg-icon" v-if="item.TypeId==='pdf'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <use xlink:href="/Content/dist/image_svg.svg?v2#Pdf" />
                                                </svg>
                                                <span v-if="item.FileData">{{item.FilePath}}</span>
                                                <a target="_blank" v-if="!item.FileData && item.FilePath" :href="item.FilePath">
                                                    {{item.FileName}}
                                                </a>
                                                <div class="thumbnail-img-delete" @click="onRemoveAttachment(i)" v-if="allowEdit"></div>
                                            </template>
                                            <template v-if="item.isImage">
                                                <a target="_blank" v-if="item.FileData" class="lightzoom" rel="group">
                                                    <img :src="item.FileData" />
                                                </a>
                                                <a target="_blank" v-if="!item.FileData && item.FilePath" :href="item.FilePath" class="lightzoom" rel="group">
                                                    <img :src="item.FilePath" />
                                                </a>
                                                <button type="button" class="btn btn-default btn-img" @click.stop="onRemoveAttachment(i)" v-if="allowEdit">
                                                    <img src="../../../img/icon-del.png" alt="" />
                                                </button>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="file-upload-zone" v-if="allowEdit">
                                        <drop-zone class="drop-area" @files-dropped="onAttachFiles">
                                            <input type="file" id="dropFiles2" ref="dropFiles2" name="dropFiles2" class="file-upload-zone-btn" accept=".jpg,.jpeg,.png,.pdf,.docx,.xlsx" multiple />
                                            <label id="dropFiles2BtnLbl" for="dropFiles2" class="file-upload-zone-lbl">Перетащите файлы или нажмите, чтобы выбрать</label>
                                        </drop-zone>
                                    </div>
                                </div>
                            </div>
                            <div class="margin-top-5">
                                <label class="input-text-lbl">
                                    Описание
                                    <span class="required" aria-required="true">*</span>
                                </label>
                                <froala-editor ref="SettingsDescription" name="SettingsDescription"
                                               :class="[{'input-error': errors.has('SettingsDescription')}]"
                                               v-validate="'required'"
                                               :disabled="!allowEdit"
                                               v-model="task.Caption">
                                </froala-editor>
                                <span class="field-validation-valid">{{ errors.first('SettingsDescription') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="block-in-page closed">
                        <h2 class="margin-bottom-20 block-in-page-collapce">Настройки</h2>
                        <div class="block-in-page-detail">
                            <div class="line-separator margin-bottom-15 margin-top-15"></div>
                            <div class="form-field-group mob-inline">
                                <div class="form-field">
                                    <div>
                                        <label class="input-text-lbl">
                                            Общие настройки
                                        </label>
                                    </div>
                                    <div class="margin-top-3">
                                        <input name="FixTT" id="FixTT" value="true" type="checkbox" class="input-checkbox"
                                               :disabled="!allowEdit"
                                               v-model="task.FixTT"
                                               @change="onFixTTChange()" />
                                        <label for="FixTT" class="input-checkbox-lbl">Фиксировать торговую точку</label>
                                    </div>
                                    <div class="margin-top-3">
                                        <input name="DenyExecutionOnSite" id="DenyExecutionOnSite" value="true" type="checkbox" class="input-checkbox"
                                               :disabled="!allowEdit"
                                               v-model="task.DenyExecutionOnSite" />
                                        <label for="DenyExecutionOnSite" class="input-checkbox-lbl">Запретить выполнение задания через сайт</label>
                                    </div>
                                    <div class="margin-top-20">
                                        <label class="input-text-lbl">
                                            Настройки для мобильного приложения
                                        </label>
                                    </div>
                                    <div class="margin-top-3">
                                        <input name="AllowToAttachPhotoMP" id="AllowToAttachPhotoMP" value="true" type="checkbox" class="input-checkbox"
                                               :disabled="!allowEdit"
                                               v-model="task.AllowToAttachPhotoMP" />
                                        <label for="AllowToAttachPhotoMP" class="input-checkbox-lbl">Разрешить прикреплять фото из галереи в мобильном приложении</label>
                                    </div>
                                    <div class="margin-top-3">
                                        <input name="RunInStore" id="RunInStore" value="true" type="checkbox" class="input-checkbox"
                                               :disabled="!allowEdit || !task.FixTT"
                                               v-model="task.RunInStore" />
                                        <label for="RunInStore" class="input-checkbox-lbl">Выполнение задания возможно только в точке</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="block-in-page closed">
                        <h2 class="margin-bottom-20 block-in-page-collapce">Поля задания</h2>
                        <div class="block-in-page-detail">
                            <div class="line-separator margin-bottom-15 margin-top-15"></div>
                            <div class="form-field-group mob-inline">
                                <div class="form-field">
                                    <label class="input-text-lbl">Тип ввода</label>
                                    <drop-down :items="fieldInputTypes"
                                               :dataField="'Value'"
                                               :textField="'Name'"
                                               :disabled="!allowEdit"
                                               v-model="task.FieldInputType"></drop-down>
                                </div>
                                <template v-if="task.FieldInputType === FieldType.Table">
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Сколько пустых строк показывать
                                            <span class="required" aria-required="true">*</span>
                                        </label>
                                        <touch-spin v-model="task.FieldTableMinRows" name="FieldTableMinRows" :decimals="0" :step="1.00" :min="1" :max="45"
                                                    v-validate="{ required: true }"
                                                    :disabled="!allowEdit"
                                                    :class="['input-text', {'input-error': errors.has('FieldTableMinRows')}]"
                                                    @change="onTableRowsChange('min')"
                                                    data-vv-as="Значение"></touch-spin>
                                        <span class="field-validation-valid">{{ errors.first('FieldTableMinRows') }}</span>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Сколько строк может добавить участник
                                        </label>
                                        <touch-spin v-model="task.FieldTableMaxRows" name="FieldTableMaxRows" :decimals="0" :step="1.00" :max="45"
                                                    :disabled="!allowEdit"
                                                    @change="onTableRowsChange('max')"
                                                    :class="['input-text']"></touch-spin>
                                    </div>
                                </template>
                            </div>
                            <div class="line-separator margin-bottom-15 margin-top-15"></div>
                            <Container @drop="onFieldSettingsDrop" :lock-axis="'y'">
                                <Draggable v-for="(settings, i) of fieldSettingsOrdered">
                                    <div class="draggable-item">
                                        <div class="form-field-group mob-inline">
                                            <div class="form-field">
                                                <div class="form-field">
                                                    <label class="input-text-lbl">
                                                        Название поля в ответе
                                                        <span class="required" aria-required="true">*</span>
                                                    </label>
                                                    <input type="text" class="input-text" placeholder="Название" maxlength="245"
                                                           :name="'settingsName' + i"
                                                           v-model="settings.name"
                                                           v-validate="'required'"
                                                           :disabled="!allowEdit"
                                                           :class="['input-text', {'input-error': errors.has('settingsName' + i)}]"
                                                           @change="onSettingsFieldChange(settings)"
                                                           data-vv-as="Название" />
                                                    <span class="field-validation-valid">{{ errors.first('settingsName' + i) }}</span>
                                                </div>
                                                <div class="form-field margin-top-5">
                                                    <label class="input-text-lbl">
                                                        Тип поля
                                                    </label>
                                                    <drop-down :items="getFieldSettingsTypes(settings)"
                                                               :dataField="'Id'"
                                                               :textField="'Name'"
                                                               v-model="settings.type"
                                                               :disabled="!allowEdit"
                                                               @change="onSettingsFieldChange(settings)"></drop-down>
                                                </div>
                                            </div>
                                            <div class="form-field">
                                                <div class="form-field">
                                                    <label class="input-text-lbl">
                                                        Описание
                                                    </label>
                                                    <textarea style="height:70px" maxlength="245"
                                                              :name="'SettingsDescription' + i"
                                                              :class="['input-memo', {'input-error': errors.has('SettingsDescription' + i)}]"
                                                              v-model="settings.description"
                                                              :disabled="!allowEdit"
                                                              data-vv-as="Описание"></textarea>
                                                </div>
                                                <div class="form-field margin-top-3">
                                                    <input :id="'settingsDeleted' + i" :name="'settingsDeleted' + i" value="true"
                                                           type="checkbox" class="input-checkbox"
                                                           v-model="settings.deleted"
                                                           :disabled="!allowEdit"
                                                           @change="onSettingsFieldChange(settings)" />
                                                    <label :for="'settingsDeleted' + i" class="input-checkbox-lbl" style="margin-top:0">Отключить поле</label>
                                                </div>
                                            </div>

                                            <div class="form-field flex" v-if="settings.type === 'sku'" style="width:200px;min-width:200px;padding-top:23px">
                                                <button type="button" class="btn" @click.stop="skuSetUpSelection(settings)">Настроить выбор</button>
                                                <button type="button" class="btn" @click.stop="skuSetUpList(task.skuList)">Настроить SKU</button>
                                            </div>

                                            <div class="form-field" style="width:35px;min-width:35px;padding-top:23px" v-if="(task.new || settings.new) && allowEdit">
                                                <button type="button" class="btn btn-default btn-img" @click.stop="onRemoveFieldSettings(settings, i)">
                                                    <img src="../../../img/icon-del.png" alt="" />
                                                </button>
                                            </div>
                                        </div>
                                        <div class="margin-top-5" v-if="settings.type === 'attach'">
                                            <label class="input-text-lbl">
                                                Выберите тип допустимых вложений
                                                <span class="required" aria-required="true">*</span>
                                            </label>
                                            <div class="form-field-group margin-top-5">
                                                <div class="form-field" style="width:auto">
                                                    <input :id="'PhotoFilesEnable' + i" :name="'PhotoFilesEnable' + i" value="true" type="checkbox" class="input-checkbox" v-model="settings.attach_photo" />
                                                    <label :for="'PhotoFilesEnable' + i" class="input-checkbox-lbl" style="margin-top:0">JPG, JPEG, PNG</label>
                                                </div>
                                                <div class="form-field" style="width:auto">
                                                    <input :id="'DocFilesEnable' + i" :name="'DocFilesEnable' + i" value="true" type="checkbox" class="input-checkbox" v-model="settings.attach_doc" />
                                                    <label :for="'DocFilesEnable' + i" class="input-checkbox-lbl" style="margin-top:0">Excel, Word</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-field" v-if="settings.type === 'select'">
                                            <label class="input-text-lbl">
                                                Массив вариантов выпадающего списка в формате ["Вариант-1", "Вариант-2"]<br>
                                                <span class="test-wrong">Двойные кавычки используются только для обозначения границ слова</span>
                                            </label>
                                            <input type="text" :name="'settingsNameSelect' + i"
                                                   :class="['input-text', {'input-error': errors.has('settingsNameSelect' + i)}]"
                                                   placeholder='Массив вариантов через запятую, напр.: ["Вариант-1", "Вариант-2"]'
                                                   v-model="settings.options"
                                                   v-validate="{required: true, jsonArray: true}"
                                                   data-vv-as="Массив"
                                                   :disabled="!allowEdit" />
                                            <span class="field-validation-valid">{{ errors.first('settingsNameSelect' + i) }}</span>
                                        </div>
                                        <div class="form-field margin-top-5" v-if="settings.type === 'string'">
                                            <input :name="'settingsNameString' + i" :id="'settingsNameString' + i" value="true" type="checkbox" class="input-checkbox"
                                                   :disabled="!allowEdit"
                                                   v-model="settings.scanner" />
                                            <label :for="'settingsNameString' + i" class="input-checkbox-lbl">Сканер</label>
                                        </div>
                                    </div>
                                </Draggable>
                            </Container>

                            <button type="button" class="btn btn-primary margin-top-15 btn-img" @click="addFieldSettings()" v-if="allowEdit">
                                <img src="../../../img/icon-plus-2.png" alt="" />
                            </button>
                        </div>
                    </div>

                    <div class="block-in-page closed" v-if="task.TaskType === TaskTypes.Cumulative">
                        <h2 class="margin-bottom-20 block-in-page-collapce">Цель</h2>
                        <div class="block-in-page-detail">
                            <div class="line-separator margin-bottom-15 margin-top-15"></div>
                            <div class="form-field-group mob-inline" v-if="task.FixTT && task.PurposeType === PurposeType.Count">
                                <div class="margin-bottom-10">
                                    <input name="PurposeOneAnswerTT" id="PurposeOneAnswerTT" value="true" type="checkbox" class="input-checkbox"
                                           :disabled="!allowEdit"
                                           v-model="task.PurposeOneAnswerTT"
                                           @change="onPurposeOneAnswerTTChange()" />
                                    <label for="PurposeOneAnswerTT" class="input-checkbox-lbl">Требуется один ответ с торговой точки</label>
                                </div>
                            </div>
                            <div class="form-field-group mob-inline">
                                <div class="form-field">
                                    <label class="input-text-lbl">Тип цели</label>
                                    <drop-down :items="purposeTypeItems"
                                               :dataField="'Value'"
                                               :textField="'Name'"
                                               :disabled="!allowEdit || task.PurposeOneAnswerTT"
                                               v-model="task.PurposeType"></drop-down>
                                </div>
                                <div class="error" v-if="!numberFieldExist && task.PurposeType === PurposeType.Summ">
                                    Необходимо добавить хотя бы одно числовое поле
                                </div>
                                <div class="form-field" v-if="numberFieldExist && task.PurposeType === PurposeType.Summ">
                                    <label class="input-text-lbl">Выбор поля ответа</label>
                                    <drop-down :items="purposeFieldItems"
                                               :dataField="'Value'"
                                               :textField="'Name'"
                                               :disabled="!allowEdit"
                                               v-model="task.PurposeField"></drop-down>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Значение цели
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <touch-spin v-model="task.PurposeValue" name="PurposeValue" :decimals="0" :step="1.00" :min="1"
                                                v-validate="{ required: true }"
                                                :disabled="!allowEdit || task.PurposeOneAnswerTT"
                                                :class="['input-text', {'input-error': errors.has('PurposeValue')}]"
                                                data-vv-as="Значение"></touch-spin>
                                    <span class="field-validation-valid">{{ errors.first('PurposeValue') }}</span>
                                </div>
                            </div>
                            <div class="form-field-group mob-inline" v-if="task.PurposeOneAnswerTT">
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Время на выполнение задания (ЧЧ:ММ:СС)
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <input-time name="PurposeTimeToCompleteFormatted"
                                                showSeconds="true"
                                                maxHours="8760"
                                                v-model="task.PurposeTimeToCompleteFormatted"
                                                v-validate="{ required: true }"
                                                :disabled="!allowEdit"
                                                @input="onChangePurposeTimeToComplete(task, 'PurposeTimeToCompleteFormatted', 'PurposeTimeToComplete')"
                                                :class="['input-text', {'input-error': errors.has('PurposeTimeToCompleteFormatted')}]"
                                                data-vv-as="Значение"></input-time>
                                    <span class="field-validation-valid">{{ errors.first('PurposeTimeToCompleteFormatted') }}</span>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Через какое время можно повторно приступить к выполнению задания (ЧЧ:ММ:СС)
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <input-time name="PurposeAllowAfterCompleteFormatted"
                                                showSeconds="true"
                                                maxHours="8760"
                                                v-model="task.PurposeAllowAfterCompleteFormatted"
                                                v-validate="{ required: true }"
                                                :disabled="!allowEdit"
                                                @input="onChangePurposeTimeToComplete(task, 'PurposeAllowAfterCompleteFormatted', 'PurposeAllowAfterComplete')"
                                                :class="['input-text', {'input-error': errors.has('PurposeAllowAfterCompleteFormatted')}]"
                                                data-vv-as="Значение"></input-time>
                                    <span class="field-validation-valid">{{ errors.first('PurposeAllowAfterCompleteFormatted') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="block-in-page closed">
                        <h2 class="margin-bottom-20 block-in-page-collapce">{{scoringHeader}}</h2>
                        <div class="block-in-page-detail">
                            <div class="line-separator margin-bottom-15 margin-top-15"></div>
                            <div class="form-field-group mob-inline">
                                <div class="form-field">
                                    <label class="input-text-lbl">Вариант начисления</label>
                                    <drop-down :items="scoringAccrualItems"
                                               :dataField="'Value'"
                                               :textField="'Name'"
                                               :disabled="!allowEdit"
                                               v-model="task.ScoringAccrual"
                                               @change="purposeFieldItemsChange()"></drop-down>
                                </div>
                                <div class="form-field" v-if="task.ScoringAccrual === ScoringAccrualTypes.DependingOnSku" style="width:200px;min-width:200px;padding-top:23px">
                                    <button type="button" class="btn" @click.stop="skuSetUpList(task.skuList)">Настроить SKU</button>
                                </div>
                                <template>
                                    <div class="error" v-if="!numberFieldExist && task.ScoringAccrual === ScoringAccrualTypes.SumPercent">
                                        Необходимо добавить хотя бы одно числовое поле
                                    </div>
                                    <div class="form-field" v-if="numberFieldExist && task.ScoringAccrual === ScoringAccrualTypes.SumPercent || task.ScoringAccrual === ScoringAccrualTypes.DependingOnSku">
                                        <label class="input-text-lbl">{{task.ScoringAccrual === ScoringAccrualTypes.DependingOnSku ? 'Множитель' : 'Выберите поле для суммы'}}</label>
                                        <drop-down :items="scoringAccrualField"
                                                   :dataField="'Value'"
                                                   :textField="'Name'"
                                                   :disabled="!allowEdit"
                                                   v-model="task.ScoringAccrualField"></drop-down>
                                    </div>
                                </template>
                                <div class="form-field" v-if="task.ScoringAccrual !== ScoringAccrualTypes.DependingOnSku">
                                    <label class="input-text-lbl">
                                        {{scoringAccrualHeader}}
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <touch-spin v-model="task.ScoringAccrualSum" name="ScoringAccrualSum"
                                                :min="0" :decimals="2" :step="0.01"
                                                v-validate="{ required: true }"
                                                :disabled="!allowEdit"
                                                :class="['input-text', {'input-error': errors.has('ScoringAccrualSum')}]"
                                                :data-vv-as="(scoringAccrualHeader)"></touch-spin>
                                    <span class="field-validation-valid">{{ errors.first('ScoringAccrualSum') }}</span>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Текст в плашке задания (за что баллы)
                                    </label>
                                    <input type="text" class="input-text" placeholder="баллов в награду" maxlength="50"
                                           :name="'scoringAccrualText'"
                                           v-model="task.ScoringAccrualText"
                                           :disabled="!allowEdit" />
                                </div>
                            </div>
                            <div class="form-field-group margin-top-5 mob-inline">
                                <div class="form-field">
                                    <label class="input-text-lbl">Активировать баллы</label>
                                    <drop-down :items="scoringActivationPeriod"
                                               :dataField="'Value'"
                                               :textField="'Name'"
                                               :disabled="!allowEdit"
                                               v-model="task.ScoringActivationPeriod"
                                               @change="scoringActivationPeriodChange()"></drop-down>
                                </div>
                                <div class="form-field" v-if="task.ScoringActivationPeriod === ScoringActivation.CumulativeForPeriod">
                                    <label class="input-text-lbl">
                                        Дата начала периода
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <drop-down :items="scoringActivationPeriodField"
                                                   :dataField="'Value'"
                                                   :textField="'Name'"
                                                   :disabled="!allowEdit"
                                                   v-model="task.ScoringActivationPeriodField"></drop-down>
                                </div>
                                <div class="form-field" v-if="task.ScoringActivationPeriod !== ScoringActivation.OnDay">
                                    <label class="input-text-lbl">
                                        Кол-во дней
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <touch-spin v-model="task.ScoringActivationCount" name="ScoringActivationCount" :decimals="0" :step="1.00"
                                                v-validate="{ required: true }"
                                                :disabled="!allowEdit"
                                                :class="['input-text', {'input-error': errors.has('ScoringActivationCount')}]"
                                                data-vv-as="Значение"></touch-spin>
                                    <span class="field-validation-valid">{{ errors.first('ScoringActivationCount') }}</span>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">Срок сгорания баллов</label>
                                    <drop-down :items="scoringBurningTime"
                                               :dataField="'Value'"
                                               :textField="'Name'"
                                               :disabled="!allowEdit"
                                               v-model="task.ScoringBurningTime"></drop-down>
                                </div>
                                <div class="form-field" v-if="task.ScoringBurningTime === ScoringBurningTime.InDays">
                                    <label class="input-text-lbl">
                                        Кол-во дней
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <touch-spin v-model="task.ScoringBurningCount" name="ScoringBurningCount" :decimals="0" :step="1.00"
                                                v-validate="{ required: true }"
                                                :disabled="!allowEdit"
                                                :class="['input-text', {'input-error': errors.has('ScoringBurningCount')}]"
                                                data-vv-as="Значение"></touch-spin>
                                    <span class="field-validation-valid">{{ errors.first('ScoringBurningCount') }}</span>
                                </div>
                                <div class="form-field" v-if="task.ScoringBurningTime === ScoringBurningTime.OnDate">
                                    <label class="input-text-lbl">
                                        Выберите дату
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <div class="input-date-lbl">
                                        <input-date name="ScoringBurningDateFormatted"
                                                    v-model="task.ScoringBurningDateFormatted"
                                                    v-validate="'required'"
                                                    :disabled="!allowEdit"
                                                    @input="onChangeDate(task, 'ScoringBurningDateFormatted', 'ScoringBurningDate')"
                                                    :class="['input-text', {'input-error': errors.has('ScoringBurningDateFormatted')}]"
                                                    todayHighlight="true"
                                                    data-vv-as="Значение"></input-date>
                                    </div>
                                    <span class="field-validation-valid">{{ errors.first('ScoringBurningDateFormatted') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="block-in-page closed">
                        <h2 class="margin-bottom-20 block-in-page-collapce">Фильтр участников</h2>
                        <div class="block-in-page-detail">
                            <div class="form-field">
                                <input name="MemberFilterActivation" id="MemberFilterActivation" value="true" type="checkbox" class="input-checkbox"
                                       :disabled="!allowEdit"
                                       v-model="task.MemberFilterActivation" @change="changedFilterActivation()" />
                                <label for="MemberFilterActivation" class="input-checkbox-lbl">Активация фильтра</label>
                            </div>
                            <template v-if="task.MemberFilterActivation">
                                <div class="line-separator margin-bottom-15 margin-top-15"></div>
                                <div class="form-field-group mob-inline">
                                    <div class="form-field">
                                        <label class="input-text-lbl">Тип фильтра</label>
                                        <drop-down :items="memberFilterVariant"
                                                   :dataField="'Value'"
                                                   :textField="'Name'"
                                                   v-model="task.MemberFilterVariant"
                                                   :disabled="!allowEdit"
                                                   @change="changedFilterVariant()"></drop-down>
                                    </div>
                                    <div class="form-field" v-if="task.MemberFilterVariant === MemberFilters.Users">
                                        <label class="input-text-lbl">Выберите участников</label>
                                        <checked-down :items="memberFilterUsers" @onBottomScrolled="onCheckedDownScroll"
                                                      :dataField="'UserId'"
                                                      :textField="'UserFio'"
                                                      :idPref="'filteruser'" 
                                                      :disabled="!allowEdit"
                                                      v-model="task.MemberFilterUsers"></checked-down>
                                    </div>
                                    <template v-else-if="task.MemberFilterVariant === MemberFilters.TradePoints">
                                        <div class="form-field">
                                            <label class="input-text-lbl">Выберите поле для фильтра</label>
                                            <drop-down :items="memberFilterField"
                                                       :dataField="'Value'"
                                                       :textField="'Name'"
                                                       v-model="task.MemberFilterField"
                                                       :disabled="!allowEdit"
                                                       @change="changedFilterField()"></drop-down>
                                        </div>
                                        <div class="form-field">
                                            <label class="input-text-lbl">Значения</label>
                                            <checked-down :items="memberFilterValue" @onBottomScrolled="onCheckedDownScroll"
                                                          :name="task.MemberFilterField"
                                                          :dataField="'Id'"
                                                          :textField="'Name'"
                                                          :idPref="'filtervalue'" 
                                                          :disabled="!allowEdit"
                                                          v-model="task.MemberFilterValue"></checked-down>
                                        </div>
                                    </template>
                                    <template v-else-if="task.MemberFilterVariant === MemberFilters.Roles">
                                        <div class="form-field">
                                            <div>
                                                <label class="input-text-lbl">Выберите роль для фильтра</label>
                                                <checked-down :items="memberFilterRoles"
                                                              :name="'MemberFilterFieldRoles'"
                                                              :dataField="'Value'"
                                                              :textField="'Name'"
                                                              :idPref="'filterrole'"
                                                              :disabled="!allowEdit"
                                                              v-model="task.MemberFilterField.Roles"
                                                              v-validate="{ required: true }"
                                                              :hasErrors="errors.has('MemberFilterFieldRoles')"
                                                              data-vv-as="Роль для фильтра"
                                                              @change="changedMemberFilterRole()"></checked-down>
                                                <span class="field-validation-valid">{{ errors.first('MemberFilterFieldRoles') }}</span>
                                            </div>
                                            <div class="" v-if="useGradeOnSelectedRoles">
                                                <label class="input-text-lbl">Выберите грейд для фильтра</label>
                                                <checked-down :items="memberFilterGrades"
                                                              :dataField="'Value'"
                                                              :textField="'Name'"
                                                              :idPref="'filtergrade'" 
                                                              :disabled="!allowEdit"
                                                              v-model="task.MemberFilterField.Grades"
                                                              @change="changedMemberFilterGrade()"></checked-down>
                                            </div>
                                        </div>
<!--                                        <div class="form-field">
                                            <label class="input-text-lbl">Выберите участников</label>
                                            <checked-down :items="memberFilterUsersOnRole"
                                                          :name="'MemberFilterUsersOnRoles'"
                                                          :loadFunction="memberFilterUsersLoad"
                                                          :dataField="'UserId'"
                                                          :textField="'UserFio'"
                                                          :idPref="'filteruserRole'"
                                                          :disabled="!allowEdit"
                                                          :rowsPage="20"
                                                          v-validate="{ required: true }"
                                                          :hasErrors="errors.has('MemberFilterUsersOnRoles')"
                                                          data-vv-as="Пользователи"
                                                          v-model="task.MemberFilterUsers"></checked-down>
                                            <span class="field-validation-valid">{{ errors.first('MemberFilterUsersOnRoles') }}</span>
                                        </div>-->
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <popup-window ref="ppSkuFieldSettings" :title="'Настройка отображения полей SKU в текущем задании'" :width="800">
            <p class="caption-help">Настройка отображения и использования полей справочника в текущем задании</p>
            <table class="table-view" id="tSkuFieldSett">
                <thead class="head-show">
                    <tr class="heading">
                        <th>Название поля</th>
                        <th>Осуществлять поиск</th>
                        <th>Сцепить для показа</th>
                    </tr>
                </thead>
                <tbody v-if="dialogSkuSettings != null">
                    <tr :key="s" v-for="(skuSettingsItem, s) of skuSettingsOrdered">
                        <td>
                            {{ skuSettingsItem.Title }}
                        </td>
                        <td class="bit">
                            <input :id="'list' + s" :name="'list' + s" v-model="skuSettingsItem.search" value="true" type="checkbox" class="input-checkbox" />
                            <label :for="'list' + s" class="input-checkbox-lbl no-text"></label>
                        </td>
                        <td class="bit">
                            <input :id="'det' + s" :name="'det' + s" v-model="skuSettingsItem.attached" value="true" type="checkbox" class="input-checkbox" />
                            <label :for="'det' + s" class="input-checkbox-lbl no-text"></label>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="updateSkuSelectionItem()">Ок</button>
                <button type="button" class="btn" @click="$refs.ppSkuFieldSettings.close()">Отмена</button>
            </div>
        </popup-window>

        <popup-window ref="ppSkuFieldList" :title="titlePopap" @onBottomScrolled="onSkuListScroll" :width="800">
            <div>
                <div class="control-block-left margin-bottom-10">
                    <p class="caption-help">{{ppSkuFieldListCaption}}</p>
                </div>
                <div class="control-block-right">
                    <div class="btns flex" v-if="allowEdit">
                        <input type="file" id="dropFiles" ref="dropFiles" name="dropFiles"
                               class="file-upload-zone-btn" accept=".xlsx" @change="onFileChange()" />

                        <button type="button" class="btn btn-primary" @click="onSkuListExport()">Экспорт</button>
                        <button type="button" class="btn btn-primary" @click="onSkuListImport()">Импорт</button>
                    </div>
                </div>
            </div>
            <table class="table-view" id="tSkuFieldSett">
                <thead class="head-show">
                    <tr class="heading">
                        <th>SKU</th>
                        <th>Активность</th>
                        <th v-if="dependingOnSku">Баллы</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="([key, sku], i) of skuListForeach">
                        <td>{{sku.name}}</td>
                        <td class="bit">
                            <input :id="'skulist_' + i" name="skulist" v-model="sku.active" value="true" type="checkbox" class="input-checkbox" />
                            <label :for="'skulist_' + i" class="input-checkbox-lbl no-text"></label>
                        </td>
                        <td class="int" v-if="dependingOnSku">
                            <touch-spin v-model="sku.bonus" name="skudet" :decimals="0" :step="1.00" :class="['input-text']"></touch-spin>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div slot='footer' class="popup-footer btns flex" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="updateSkuListItem()">Ок</button>
                <button type="button" class="btn" @click="$refs.ppSkuFieldList.close()">Отмена</button>
            </div>
        </popup-window>

        <popup-window ref="ppCopyTasksSettings" :title="'Дублировать задание'" :width="600" :modal="true">
            <div class="form-field">
                <label class="input-text-lbl">
                    Название
                    <span class="required" aria-required="true">*</span>
                </label>
                <input maxlength="256" type="text"
                       :name="'CopySettingsName'"
                       :class="['input-text', {'input-error': errors.has('CopySettingsName')}]"
                       v-model="taskCopy.Name"
                       v-validate="'required'"
                       data-vv-as="Название" />
                <span class="field-validation-valid">{{ errors.first('SCopyettingsName') }}</span>
            </div>
            <div class="form-field margin-top-5">
                <label class="input-text-lbl">
                    Описание
                    <span class="required" aria-required="true">*</span>
                </label>
                <textarea rows="10" maxlength="2000"
                          :name="'CopySettingsDescription'"
                          :class="['input-memo', {'input-error': errors.has('CopySettingsDescription')}]"
                          v-model="taskCopy.Caption"
                          v-validate="'required'"
                          data-vv-as="Описание"></textarea>
                <span class="field-validation-valid">{{ errors.first('CopySettingsDescription') }}</span>
            </div>
            <div class="form-field flex">
                <div>
                    <label class="input-text-lbl">
                        Дата начала
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <div class="input-date-lbl">
                        <input-date name="CopyStartDateFormatted"
                                    v-validate="'required'"
                                    v-model="taskCopy.StartDateFormatted"
                                    @input="onChangeDate(taskCopy, 'StartDateFormatted', 'StartDate')"
                                    :class="['input-text', {'input-error': errors.has('CopyStartDateFormatted')}]"
                                    todayHighlight="true"
                                    data-vv-as="Дата начала"></input-date>
                    </div>
                    <span class="field-validation-valid">{{ errors.first('CopyStartDateFormatted') }}</span>
                </div>
                <div class="margin-left-15">
                    <label class="input-text-lbl">
                        Дата окончания
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <div class="input-date-lbl">
                        <input-date name="CopyEndDateFormatted"
                                    v-validate="'required'"
                                    v-model="taskCopy.EndDateFormatted"
                                    @input="onChangeDate(taskCopy, 'EndDateFormatted', 'EndDate')"
                                    :class="['input-text', {'input-error': errors.has('CopyEndDateFormatted')}]"
                                    todayHighlight="true"
                                    data-vv-as="Дата окончания"></input-date>
                    </div>
                    <span class="field-validation-valid">{{ errors.first('CopyEndDateFormatted') }}</span>
                </div>
            </div>
            <div class="btns flex margin-top-20" data-toggle="buttons">
                <button type="button" class="btn btn-primary" @click="copyTasks()">Ок</button>
                <button type="button" class="btn" @click="$refs.ppCopyTasksSettings.close()">Отмена</button>
            </div>
        </popup-window>

        <vue-headful title="Задания" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'
    import { Container, Draggable } from 'vue-smooth-dnd'
    import {
      TaskTypes,
      FieldTypes,
      PurposeType,
      ScoringAccrualTypes,
      ScoringBurningTime,
      MemberFilters,
      ScoringActivation,
      UserLevelCode
    } from '../../enums'
    import imgMixin from '../../helpers/img-mixin'

    let backendApi = new BackendApi();

    const FieldSettingsTypes= [
            { Id: 'date', Name: 'Дата' },
            { Id: 'select', Name: 'Список' },
            { Id: 'sku', Name: 'Список SKU' },
            { Id: 'int', Name: 'Целое число' },
            { Id: 'decimal', Name: 'Дробное число' },
            { Id: 'string', Name: 'Строковое значение' },
            { Id: 'bool', Name: 'Галочка (да или нет)' },
            { Id: 'attach', Name: 'Вложение' }
    ];
    export default {
        name: "tasks-edit",

        props: ['info'],

        mixins: [imgMixin],

        components: { Container, Draggable },

        data() {
            return {
                task: null,
                file: null,
                deleteImage: false,
                taskTypeItems: [
                    { Value: 1, Name: 'Накопительное' },
                    { Value: 2, Name: 'Простое' }
                ],
                fieldInputTypes: [
                    { Value: 1, Name: 'Отдельные поля' },
                    { Value: 2, Name: 'Таблица' }
                ],

                purposeTypeItems: [
                    { Value: 1, Name: 'Количество принятых ответов' },
                    { Value: 2, Name: 'Сумма по полю ответа' }
                ],
                purposeFieldItems: [],
                scoringAccrualItems: [ { Value: 1, Name: 'Фиксировано' }],
                scoringAccrualField: [],
                scoringActivationPeriodField: [],
                scoringActivationPeriod: [
                    { Value: 1, Name: 'В день начисления' },
                    { Value: 2, Name: 'Через N дней после начисления' },
                    { Value: 3, Name: 'По окончанию месяца через N дней' },
                    { Value: 4, Name: 'Суммарно за период (месяц)' }
                ],
                scoringBurningTime: [
                    { Value: 1, Name: 'Бессрочные' },
                    { Value: 2, Name: 'Через N дней с даты начисления' },
                    { Value: 3, Name: 'В указанную дату' }
                ],
                memberFilterVariant: [
                    {Value: 1, Name: 'Выбор пользователей' },
                    {Value: 2, Name: 'Фильтр по торговым точкам'},
                    {Value: 3, Name: 'Фильтр по ролям'}
                ],
                memberFilterUsers: [],
                memberFilterField: [],
                memberFilterRoles: [],
                memberFilterValue: [],
                memberFilterGrades: [],
                memberFilterUsersOnRole: [],
                allowEdit: true,
                TaskTypes: TaskTypes,
                FieldType: FieldTypes,
                PurposeType: PurposeType,
                ScoringAccrualTypes: ScoringAccrualTypes,
                ScoringBurningTime: ScoringBurningTime,
                MemberFilters: MemberFilters,
                ScoringActivation: ScoringActivation,
                counterField: 0,
                numberFieldExist: false,
                dialogSkuSettings: null,
                currentSkuSettings: null,
                dialogSkuList: { },
                currentSkuList: null,
                page: 1,
                canBeLoaded: true,
                pageCheckedDown: 1,
                canBeLoadedCheckedDown: true,
                loading: false,
                filter: null,
                titlePopap: 'Настройка отображения SKU',
                dictSettings: null,
                taskCopy: {},
                useGradeOnSelectedRoles: false,
                changedFilterToRoleUsers: true
            }
        },

        computed: {
            fieldSettingsOrdered: function () {
                return _.orderBy(this.task.FieldSettings, 'itemOrder');
            },

            fieldSettingsStr() {
                for (let s of this.task.FieldSettings) {
                    if (s.type === 'bool') {
                        s.options = '["Нет", "Да"]';
                        s.dbType = 'bit';
                    }
                    else if (s.type === 'int') {
                        s.dbType = 'int';
                    }
                    else if (s.type === 'sku') {
                        s.dbType = 'int';
                        s.options = JSON.stringify(s.sku);
                        //delete s.sku;
                    }
                    else if (s.type === 'decimal') {
                        s.dbType = 'decimal(18,2)';
                    }
                    else if (s.type === 'select') {
                        s.dbType = 'nvarchar(256)';
                    }
                    else if(s.type === 'string') {
                        s.dbType = 'nvarchar(256)';
                        s.options = {};
                        s.options.scanner = s.scanner ? true : false;
                        s.options = JSON.stringify(s.options);
                    }
                        //scanner
                    else if (s.type === 'attach') {
                        s.dbType = 'nvarchar(256)';
                        s.options = [];
                        if (s.attach_photo) s.options.push('photo');
                        if (s.attach_doc) s.options.push('doc');
                        delete s.attach_photo;
                        delete s.attach_doc;
                        s.options = JSON.stringify(s.options);
                    }
                    else if (s.type === 'date') {
                        s.dbType = 'date';
                    }
                    delete s.new;
                    //delete s.sku;
                }
                return this.task.FieldSettings;
            },

            memberFilterUsersStr() {
                if (this.task.MemberFilterUsers) {
                    for (let s of this.task.MemberFilterUsers) {
                        delete s.Checked;
                        delete s.Hidden;
                        //delete s.UserFio;
                    }
                    return JSON.stringify(this.task.MemberFilterUsers);
                }
                else return null;
            },

            memberFilterValueStr() {
                if (this.task.MemberFilterValue) {
                    for (let s of this.task.MemberFilterValue) {
                        delete s.Checked;
                        delete s.Hidden;
                        if (!s.Id)
                            delete s.Id;
                    }
                    return JSON.stringify(this.task.MemberFilterValue);
                }
                else return null;
            },

            MemberFilterFieldStr() {
                if(this.task.MemberFilterVariant === this.MemberFilters.Roles && this.task.MemberFilterField) {
                    if(this.task.MemberFilterField.Roles) {
                        for(let s of this.task.MemberFilterField.Roles) {
                            delete s.Checked;
                            delete s.Hidden;
                        }
                    }
                    if(this.task.MemberFilterField.Grades) {
                        for(let s of this.task.MemberFilterField.Grades) {
                            delete s.Checked;
                            delete s.Hidden;
                        }
                    }
                    return JSON.stringify(this.task.MemberFilterField);
                }
                else return this.task.MemberFilterField;
            },

            scoringHeader() {
                return this.task.TaskType === this.TaskTypes.Cumulative ? 'Баллы за успешное прохождение' : 'Баллы за каждый ответ';
            },

            scoringAccrualHeader() {
                return this.task.ScoringAccrual === this.ScoringAccrualTypes.Fixed ? 'Сумма баллов' : 'Процент';
            },

            ppSkuFieldListCaption() {
                return (this.task != null && this.task.ScoringAccrual === this.ScoringAccrualTypes.DependingOnSku) ?
                    'Настройка отображения и начисления баллов за каждое SKU в текущем задании' : 'Настройка отображения SKU в текущем задании';
            },

            dependingOnSku() {
                return this.task != null && this.task.ScoringAccrual === this.ScoringAccrualTypes.DependingOnSku;
            },

            skuSettingsOrdered() {
                if (this.dialogSkuSettings == null) {
                    return null;
                }

                return _.orderBy(Object.values(this.dialogSkuSettings.sku), 'SettingsOrder');
            },

            skuListForeach() {
                return Object.entries(this.dialogSkuList).sort(([, a], [, b]) => a.order - b.order);
            }
        },

        watch: {
            'task.Preview': function () {
                this.task.PreviewFormatted = this.task.Preview ? this.task.Preview.replace(/\n/g, '<br>') : null;
            },

            '$route'(to, from) {
                // Маршрут меняется,  страница обновляется
                this.$router.go(0);
            }
        },

        methods: {
            getFieldSettingsTypes(field) {
                if (field.deleted && field.type === 'sku') {
                    return FieldSettingsTypes;
                }
                else if (_.some(this.task.FieldSettings, x => x.type === 'sku' && x.id !== field.id && !x.deleted)){
                    return FieldSettingsTypes.filter(x => x.Id !== 'sku');
                }
                return FieldSettingsTypes;
            },

            urlFileData(fileData) {
                return 'background-image: url(' + fileData + ')';
            },

            back() {
                this.$router.back();
            },

            loadTask() {
                let vm = this;

                if (vm.info.User.MainRole !== 'administrators' && !vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit)) {
                    vm.back();
                    return new Promise(resolve => resolve());
                }

                let id = parseInt(this.$route.params.id);
                if (id === 0) {
                    this.task = {
                        Id: 0,
                        new: true,
                        TasksAttachments: [],
                        FieldSettings: [],
                        Fact: 0,
                        QntDone: 0,
                        FieldTableMinRows: 1,
                        skuList: {},
                        VisualSettings: {AnswerBtnAddText: null}
                    };

                    return new Promise(resolve => resolve());
                }
                else {
                    return backendApi.tasksLoad(id).then(function (response) {
                        console.info('task.edit -> load, response:', response.data);
                        if (response.hasError) {
                            if (response.status === 403) {
                                UI.toastr.error('Запрещено');
                                vm.$router.back();
                            } else
                                UI.toastr.error('Ошибка при загрузке задания');
                        }
                        else {
                            if (response.data == null) {
                                vm.$router.back();
                            }

                            vm.task = Object.assign(response.data.task, { Files: [] });
                            //vm.bonus = Object.assign(response.data.bonus);
                            //vm.task = Object.assign(response.data, {FileData: null});
                            vm.task.StartDateFormatted = moment(vm.task.StartDate).format('DD.MM.YYYY');
                            if (vm.task.EndDate) {
                                vm.task.EndDateFormatted = moment(vm.task.EndDate).format('DD.MM.YYYY');
                            }
                            if (vm.task.ScoringBurningDate) {
                                vm.task.ScoringBurningDateFormatted = moment(vm.task.ScoringBurningDate).format('DD.MM.YYYY');
                            }
                            if (vm.task.PurposeTimeToComplete) {
                                vm.task.PurposeTimeToCompleteFormatted = vm.formatTime(vm.task.PurposeTimeToComplete);
                            }
                            if (vm.task.PurposeAllowAfterComplete) {
                                vm.task.PurposeAllowAfterCompleteFormatted = vm.formatTime(vm.task.PurposeAllowAfterComplete);
                            }

                            for (let s of vm.task.FieldSettings) {
                                if(s.type == 'attach' && s.options) {
                                    let options = JSON.parse(s.options);
                                    s.attach_photo = options.indexOf('photo') > -1;
                                    s.attach_doc = options.indexOf('doc') > -1;
                                }
                                else if(s.type == 'sku') {
                                    if(s.options) s.sku = JSON.parse(s.options);
                                    else s.sku = {};
                                }
                                else if(s.type == 'string') {
                                    if(s.options) {
                                        s.options = JSON.parse(s.options);
                                        s.scanner = s.options.scanner;
                                    }
                                }
                            }
                            let skuList = { };
                            for (let sb of vm.task.SkuBonusList) {
                                skuList[sb.SkuId.toString()] = { SkuId: sb.SkuId, Active: sb.Active, Bonus: sb.Bonus };
                            }
                            vm.task.skuList = skuList;

                            if((vm.task.MemberFilterVariant === 1 || vm.task.MemberFilterVariant === 3) && vm.task.MemberFilterUsers)
                                vm.task.MemberFilterUsers = JSON.parse(vm.task.MemberFilterUsers);
                            if(vm.task.MemberFilterVariant === 3 && vm.task.MemberFilterField) {
                                vm.task.MemberFilterField = JSON.parse(vm.task.MemberFilterField);
                                vm.changedMemberFilterRole();
                            }
                            if (vm.task.FieldTableMinRows == null) vm.task.FieldTableMinRows = 1;
                            vm.purposeFieldItemsChange();
                            vm.scoringActivationPeriodChange();

                            vm.task.TasksAttachments.forEach(x => {
                                switch (x.FileName.split('.').pop()) {
                                    case 'jpg':
                                    case 'jpeg':
                                    case 'png':
                                        x.isImage = true;
                                        break;
                                    default:
                                        x.TypeId = x.FileName.split('.').pop();
                                        break;
                                }
                            });
                            if (vm.task.MemberFilterVariant === 2 && vm.task.MemberFilterValue)
                                vm.task.MemberFilterValue = JSON.parse(vm.task.MemberFilterValue);
                            //console.info('this.task.Files', vm.task.MemberFilterVariant, vm.task.MemberFilterValue);

                            //vm.loadMemberFilter(); 
                            vm.onTaskTypeChange();
                            vm.allowEdit = vm.task.QntDone === 0 || vm.info.User.MainRole === 'administrators';
                        }
                    })
                }
            },

            saveTasks() {
                let vm = this;

                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        
                        if (vm.task.new)
                            vm.task.ProjectId = localStorage.getItem('selectedProjectId');
                        if (vm.task.StartDate > vm.task.EndDate) {
                            UI.toastr.error('Дата окончания не может быть раньше даты начала');
                            return;
                        }
                        
                        if (vm.task.TaskType === vm.TaskTypes.Cumulative && (vm.task.PurposeType === vm.PurposeType.Summ || vm.task.ScoringAccrual === vm.ScoringAccrualTypes.SumPercent) && !vm.numberFieldExist) {
                            UI.toastr.error('Необходимо добавить хотя бы одно числовое поле');
                            return;
                        }
                        else {
                            let qnt = 0;
                            let qnt1 = 0;

                            for (let s of vm.task.FieldSettings) {
                                if (!s.deleted) {
                                    qnt++;
                                }
                                if (s.type == 'attach' && !s.attach_photo && !s.attach_doc) {
                                    UI.toastr.error('Выберите тип допустимых вложений');
                                    return;
                                }
                                if (s.type == 'sku') {
                                    qnt1 = 0;
                                    if (s.sku && s.sku.Name) {
                                        for (let s1 in vm.dictSettings) {
                                            if (s.sku[s1] && s.sku[s1].attached) qnt1++;
                                        }
                                    }
                                    if (qnt1 === 0) {
                                        UI.toastr.error('Настройте отображение полей SKU для "' + s.name + '"');
                                        return;
                                    }
                                }
                            }
                            if (vm.task.FieldSettings.length === 0 || qnt === 0) {
                                UI.toastr.error('Необходимо добавить хотя бы одно поле');
                                return;
                            }
                        }
                        if (vm.task.ScoringAccrual === vm.ScoringAccrualTypes.DependingOnSku) {
                            let qnt = 0;
                            for (let s of vm.task.SkuBonusList) {
                                if (s.Active && s.Bonus > 0) qnt++; 
                            }
                            if (qnt === 0) {
                                UI.toastr.error('Необходимо заполнить баллы');
                                return;
                            }
                        }
                        
                        UI.blockUI('.dataContent', 'Сохранение...');

                        //let saveObj = Object.assign({}, vm.news, {
                        //    StartDate: moment(vm.news.StartDateFormatted, 'DD.MM.YYYY').format(),
                        //    EndDate: moment(vm.news.EndDateFormatted, 'DD.MM.YYYY').format(),
                        //    DeleteImage: vm.deleteImage,
                        //    ProjectId: selectedProjectId != null ? parseInt(selectedProjectId) : null,
                        //    Body: $('[name="Body"]').froalaEditor('html.get', true)
                        //});
                        //saveObj.ImageStyle = JSON.stringify(saveObj.ImageStyle);

                        let saveObj = Object.assign({}, vm.task, {});
                        saveObj.FieldSettings = vm.fieldSettingsStr;


                        saveObj.MemberFilterUsers = vm.memberFilterUsersStr;
                        saveObj.MemberFilterValue = vm.memberFilterValueStr;
                        saveObj.MemberFilterField = vm.MemberFilterFieldStr;
                        if (!saveObj.MemberFilterActivation) {
                            saveObj.MemberFilterVariant = null;
                        }
                        if (saveObj.MemberFilterVariant === null) {
                            saveObj.MemberFilterUsers = null;
                            saveObj.MemberFilterField = null;
                            saveObj.MemberFilterValue = null;
                        } else if (saveObj.MemberFilterVariant === this.MemberFilters.Users) {
                            saveObj.MemberFilterField = null;
                            saveObj.MemberFilterValue = null;
                        } else if (saveObj.MemberFilterVariant === this.MemberFilters.TradePoints) {
                            saveObj.MemberFilterUsers = null;
                        }
                        if (saveObj.FieldInputType === vm.FieldType.Single) {
                            saveObj.FieldTableMinRows = null;
                            saveObj.FieldTableMaxRows = null;
                        }

                        console.info('vm.task.FieldSettings', saveObj.FieldSettings);
                        //UI.unblockUI('.dataContent');
                        //return;
                        backendApi.tasksSave(saveObj).then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при сохранении задания');
                            } else {
                                UI.toastr.success('Успешно сохранено');
                                //vm.$router.push('/tasks/edit/' + response.data);
                                vm.$router.push('/tasks');
                            }
                        });
                    }
                });
            },

            deleteTasks(){
                let vm = this;

                if (confirm('Вы уверены?')) {
                    UI.blockUI('.portlet', 'Удаление...');
                    backendApi.tasksDelete(vm.task.Id).then(function (response) {
                        UI.unblockUI('.portlet');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении задания');
                        } else {
                            UI.toastr.success('Успешно удалено');
                            that.$router.push('/tasks');
                        }
                    });
                }
            },

            loadMemberFilter(isSelectAll) {
                let vm = this;
                if(!vm.task.MemberFilterActivation)
                    return;
                let typeFilter = vm.task.MemberFilterVariant;
                if(!typeFilter) {
                    typeFilter = 1;
                }
                let colName = 'Name';
                let projectId = parseInt(this.$route.params.projectId);
                if (vm.task && vm.task.MemberFilterField) {
                    colName = vm.task.MemberFilterField;
                    //projectId = vm.task.ProjectId;
                }
                vm.loading = true;
                //console.info('loadMemberFilter', colName, projectId, vm.task)
                //if (!projectId) projectId = localStorage.getItem('selectedProjectId');
                let take = 50;
                if(isSelectAll)
                    take = 5000;
                return vm.callApiWrapper(backendApi.tasksMemberFilter(colName, projectId, (vm.pageCheckedDown - 1) * 50, take, typeFilter, vm.task.Id))
                    .then(function (resp) {
                        if (resp.hasError) {
                            UI.toastr.error('Ошибка при загрузке списка');
                        } else {
                            if(resp.data.filterValue && resp.data.filterValue.length > 0) {
                                const uniqueNames = new Set(vm.memberFilterValue.map(item => item.Name));
                                const uniqueValues = resp.data.filterValue.filter(item => {
                                    if (!uniqueNames.has(item.Name)) {
                                        uniqueNames.add(item.Name);
                                        return true;
                                    }
                                    return false;
                                });
                                vm.memberFilterValue.push(...uniqueValues);
                            } else if(resp.data.users && resp.data.users.length > 0) {
                                vm.memberFilterUsers = Object.assign(resp.data.users);
                            } else {
                                vm.canBeLoadedCheckedDown = false;
                            }
                        }
                        vm.loading = false;
                    })
                    .catch((err) => {
                        console.info('err', err)
                    });
            },

            onRemoveAttachment(i) {
                if (confirm('Удалить файл?')) {
                    this.task.TasksAttachments.splice(i, 1);
                    this.$refs.dropFiles2.value = '';
                }
            },

            onChangeDate(item, formatted, raw) {
                item[raw] = moment(item[formatted], 'DD.MM.YYYY').format();
            },

            onFieldSettingsDrop(dropResult) {
                let vm = this;

                if (dropResult.removedIndex === dropResult.addedIndex) {
                    return;
                }

                let temp = _.orderBy(vm.task.FieldSettings, 'itemOrder');
                let itemToAdd;
                if (dropResult.removedIndex != null) {
                    itemToAdd = temp.splice(dropResult.removedIndex, 1)[0];
                }
                if (dropResult.addedIndex !== null) {
                    temp.splice(dropResult.addedIndex, 0, itemToAdd)
                }

                let order = 1;
                temp.forEach((x) => {
                    x.itemOrder = order++;
                });

                vm.task.FieldSettings = temp;
            },

            onFieldSettingsTypesChange(settings) {
                if (settings.type == 'int' || settings.type == 'decimal') {
                    this.purposeFieldItemsChange();
                }
            },

            addFieldSettings() {
                let newOrder = 1;
                this.task.FieldSettings.forEach(x => {
                    if (x.itemOrder != undefined && x.itemOrder >= newOrder) {
                        newOrder = x.itemOrder + 1;
                    }
                });
                this.counterField--;
                this.task.FieldSettings.push({ type: 'string', deleted: false, new: true, itemOrder: newOrder, id: this.counterField });
            },

            onRemoveFieldSettings(settings, i) {
                //settings.deleted = true;
                this.task.FieldSettings.splice(i, 1);
                this.purposeFieldItemsChange();
            },

            purposeFieldItemsChange() {
                let vm = this;
                vm.purposeFieldItems = [];
                vm.scoringAccrualField = [];
                if (vm.task.ScoringAccrual === vm.ScoringAccrualTypes.DependingOnSku)
                    vm.scoringAccrualField.push({ Value: null, Name: 'Не выбрано' });
                for (let s of vm.task.FieldSettings) {
                    if (!s.deleted && (s.type == 'int' || s.type == 'decimal')) {
                        vm.purposeFieldItems.push({ Value: s.id, Name: s.name });
                        vm.scoringAccrualField.push({ Value: s.id, Name: s.name });
                    }
                }
                //console.info('purposeFieldItems', this.purposeFieldItems);
                vm.numberFieldExist = vm.purposeFieldItems.length > 0;

                vm.scoringAccrualChanged();
            },

            scoringActivationPeriodChange() {
                let vm = this;
                vm.scoringActivationPeriodField = [];
                if (vm.task.ScoringActivationPeriod === ScoringActivation.CumulativeForPeriod)
                    vm.scoringActivationPeriodField.push({ Value: null, Name: 'Дата ответа' });
                for (let s of vm.task.FieldSettings) {
                    if (!s.deleted && (s.type == 'date')) {
                        vm.scoringActivationPeriodField.push({ Value: s.id, Name: s.name });
                    }
                }
            },

            onSettingsFieldChange(settings, i) {
                this.purposeFieldItemsChange();
            },

            onTaskTypeChange() {
                this.scoringAccrualChanged();
            },

            onFixTTChange() {
                if (!this.task.FixTT) {
                    this.task.PurposeOneAnswerTT = false;
                    this.task.RunInStore = false;
                }
            },

            onPurposeOneAnswerTTChange() {
                this.task.PurposeValue = 1;
            },

            onChangePurposeTimeToComplete(item, formatted, raw) {
                let parts = item[formatted].split(':');
                let h = parseInt(parts[0]),
                    m = parseInt(parts[1]),
                    s = parseInt(parts[2]);
                item[raw] = h * 3600 + m * 60 + s;
            },

            scoringAccrualChanged() {
                if (this.task.TaskType === this.TaskTypes.Cumulative)
                    this.scoringAccrualItems = [{ Value: 1, Name: 'Фиксировано' }];
                else
                    this.scoringAccrualItems = [{ Value: 1, Name: 'Фиксировано' }, { Value: 2, Name: 'Процент от суммы по полю' }];
                if (this.task.FieldSettings.find(x => x.type === 'sku' && !x.deleted))
                    this.scoringAccrualItems.push({ Value: 3, Name: 'В зависимости от SKU' });
            },

            onAttachFiles(obj) {
                let files = obj.files;
                let vm = this;
                let filename = '';
                if (files && files.length) {
                    for (let file of files) {
                        filename = file.name.toLowerCase();
                        if (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png') ||
                            filename.endsWith('.docx') || filename.endsWith('.xlsx') || filename.endsWith('.pdf')) {
                            if (file.size > 50 * 1024 * 1024) {
                                UI.toastr.error('Превышен размер. Выберите другой файл');
                                $('[name="dropFiles2"]').val('');
                            } else {
                                let img = { Id: 0, FileName: file.name, FileData: null, FilePath: file.name };
                                if (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png'))
                                    img.isImage = true;
                                else if (filename.endsWith('.docx')) img.TypeId = 'docx';
                                else if (filename.endsWith('.xlsx')) img.TypeId = 'xlsx';
                                else if (filename.endsWith('.pdf')) img.TypeId = 'pdf';
                                let reader = new FileReader();
                                reader.onload = function (e) {
                                    img.FileData = e.target.result;

                                    vm.task.TasksAttachments.push(img);
                                };
                                reader.readAsDataURL(file);
                            }
                        }
                        else {
                            UI.toastr.error('Не верный формат файла ' + filename + ', разрешено: .jpg,.jpeg,.png,.pdf,.docx,.xlsx');
                        }
                    }
                }
            },

            skuSetUpSelection(settingsItem) {
                let vm = this;

                vm.currentSkuSettings = settingsItem;
                if (!vm.currentSkuSettings.sku)
                    vm.currentSkuSettings.sku = {};
                for (let s in vm.dialogSkuSettings.sku) {
                    if (vm.currentSkuSettings.sku[s]) {
                        vm.dialogSkuSettings.sku[s].search = vm.currentSkuSettings.sku[s].search;
                        vm.dialogSkuSettings.sku[s].attached = vm.currentSkuSettings.sku[s].attached;
                    }
                    else {
                        vm.dialogSkuSettings.sku[s].search = false;
                        vm.dialogSkuSettings.sku[s].attached = false;
                    }
                }
                vm.dialogSkuSettings.__ob__.dep.notify();

                vm.onShowModal('ppSkuFieldSettings');
            },

            skuSetUpList(skuList) {
                let vm = this;
                vm.titlePopap = vm.task.ScoringAccrual === vm.ScoringAccrualTypes.DependingOnSku ? 'Настройка отображения и начисления баллов за SKU' : 'Настройка отображения SKU';
                
                vm.currentSkuList = skuList;

                for(let [s, e] of vm.skuListForeach) {
                    if(vm.currentSkuList[s]) {
                        vm.dialogSkuList[s].active = vm.currentSkuList[s].Active;
                        vm.dialogSkuList[s].bonus = vm.currentSkuList[s].Bonus;
                    }
                }

                vm.onShowModal('ppSkuFieldList');
            },

            updateSkuSelectionItem() {
                let vm = this;
                for (let s in vm.dialogSkuSettings.sku) {
                    if (vm.currentSkuSettings.sku[s]) {
                        vm.currentSkuSettings.sku[s].search = vm.dialogSkuSettings.sku[s].search;
                        vm.currentSkuSettings.sku[s].attached = vm.dialogSkuSettings.sku[s].attached;
                    }
                    else {
                        vm.currentSkuSettings.sku[s] = {
                            search: vm.dialogSkuSettings.sku[s].search,
                            attached: vm.dialogSkuSettings.sku[s].attached
                        };
                    }
                }
                vm.currentSkuSettings.__ob__.dep.notify();

                this.$refs.ppSkuFieldSettings.close();
            },

            updateSkuListItem() {
                let vm = this;
                vm.task.SkuBonusList = [];
                for(let [s, e] of vm.skuListForeach) {
                    if (vm.currentSkuList[s]) {
                        vm.currentSkuList[s].Active = vm.dialogSkuList[s].active;
                        vm.currentSkuList[s].Bonus = vm.dialogSkuList[s].bonus;
                        vm.task.SkuBonusList.push({ SkuId: vm.dialogSkuList[s].id, Active: vm.dialogSkuList[s].active, Bonus: vm.dialogSkuList[s].bonus});
                    }
                    else if(vm.dialogSkuList[s].active) {
                        vm.currentSkuList[s] = {
                            SkuId: vm.dialogSkuList[s].id,
                            Active: vm.dialogSkuList[s].active,
                            Bonus: vm.dialogSkuList[s].bonus
                        };
                    }
                }

                this.$refs.ppSkuFieldList.close();
            },

            loadSettings() {
                let vm = this;
                let projectId = parseInt(this.$route.params.projectId);
                this.callApiWrapper(backendApi.skuSettings(projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки настроек sku');
                        }
                        else {
                            if (resp.data) {
                                //console.info('resp.data', resp.data)
                                vm.dictSettings = {};
                                for (let s of resp.data) {
                                    if (!vm.dictSettings[s.FieldName]) {
                                        vm.dictSettings[s.FieldName] = s;
                                    }
                                }

                                let sList = {
                                    sku: {

                                    }
                                };
                                for (let s in vm.dictSettings) {
                                    sList.sku[s] = { search: false, attached: false, Title: vm.dictSettings[s].Title, SettingsOrder: vm.dictSettings[s].SettingsOrder };
                                }
                                vm.dialogSkuSettings = sList;
                            }
                        }
                    });

                vm.loadSkuList();
            },

            loadSkuList() {
                let vm = this;
                let projectId = parseInt(this.$route.params.projectId);
                vm.loading = true;
                this.callApiWrapper(backendApi.skuShortList((this.page - 1) * 50, 50, projectId))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки настроек sku');
                        }
                        else {
                            if(resp.data && resp.data.length) {
                                let counter = Object.entries(vm.dialogSkuList).length + 1;
                                for (let s of resp.data) {
                                    let newItemKey = s.Id.toString();
                                    if (!vm.dialogSkuList[newItemKey]) {
                                        let newItem = {id: s.Id, name: s.Name, active: false, bonus: 0, order: counter};
                                        if (vm.task && vm.task.skuList[newItemKey]) {
                                            newItem.active = vm.task.skuList[newItemKey].Active;
                                            newItem.bonus = vm.task.skuList[newItemKey].Bonus;
                                        }
                                        vm.$set(vm.dialogSkuList, newItemKey, newItem);
                                        counter = counter + 1;
                                    }
                                }
                            }
                            else
                                vm.canBeLoaded = false;
                        }
                        vm.loading = false;
                    })
            },

            loadRoles() {
                let vm = this;
                let projectId = parseInt(this.$route.params.projectId);
                vm.memberFilterField = [
                    { Value: 'Name', Name: 'Название' },
                    { Value: 'ExternalId', Name: 'Внешний ID' },
                    { Value: 'SkuLink', Name: 'Поле для связи' },
                    { Value: 'Region', Name: 'Регион' },
                    { Value: 'Area', Name: 'Область' },
                    { Value: 'City', Name: 'Город' },
                    { Value: 'Address', Name: 'Адрес' },
                ];
                return this.callApiWrapper(backendApi.rolesList(projectId))
                    .then(function (resp) {
                        if (resp.data) {
                            let roles = resp.data.Roles;

                            for (let r = 0; r < roles.length; r++) {
                                if (!roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.ttAccess)) {
                                    vm.memberFilterField.push({Value: 'TradePointRole_' + roles[r].Id, Name: roles[r].Name});
                                }
                                if(roles[r].Claims.find(x => x.ClaimId === vm.claimEnums.tasksPage)) {
                                    let item = {Value: roles[r].Id, Name: roles[r].Name, LevelsInProject: []};
                                    for(let l = 0; l < roles[r].LevelsInProject.length; l++) {
                                        switch(roles[r].LevelsInProject[l]) {
                                            case UserLevelCode.Bronze:
                                                item.LevelsInProject.push({Id: 1, Name: 'Бронза'});
                                                break;
                                            case UserLevelCode.Silver:
                                                item.LevelsInProject.push({Id: 2, Name: 'Серебро'});
                                                break;
                                            case UserLevelCode.Gold:
                                                item.LevelsInProject.push({Id: 3, Name: 'Золото'});
                                                break;
                                            case UserLevelCode.Platina:
                                                item.LevelsInProject.push({Id: 4, Name: 'Платина'});
                                                break;
                                            case UserLevelCode.GradeB:
                                                item.LevelsInProject.push({Id: 5, Name: 'Грейд B'});
                                                break;
                                            case UserLevelCode.GradeA:
                                                item.LevelsInProject.push({Id: 6, Name: 'Грейд A'});
                                                break;
                                            case UserLevelCode.GradeS:
                                                item.LevelsInProject.push({Id: 7, Name: 'Грейд S'});
                                                break;
                                        }
                                    }
                                    vm.memberFilterRoles.push(item);
                                }
                            }
                        }
                    });
            },

            onSkuListScroll() {
                let vm = this;
                if (!vm.loading && vm.canBeLoaded) {
                    vm.page++;
                    vm.loadSkuList();
                }
            },

            onSkuListExport() {
                let vm = this;
                let ttObject = {taskId: vm.task.Id, }
                let saveObj = Object.assign({}, vm.task.skuList, {});
                console.info('onSkuListExport', vm.task.skuList, JSON.stringify(vm.task.skuList), saveObj);
                UI.blockUI('#app');
                this.callApiWrapper(backendApi.tasksExportSku(Object.assign({}, vm.task.skuList, {})))
                    .then(function (resp) {
                        if(resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                            console.info('resp', resp);
                        }
                        else {
                            let exportFile = resp.data;
                            if(exportFile != null) {
                                UI.downloadFileByBytes(exportFile, "SKU Задания.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            onSkuListImport() {
                //$('#dropFiles').click();
                document.getElementById('dropFiles').click();
            },

            onTableRowsChange(minmax) {
                let vm = this;
                if (vm.task.FieldTableMaxRows && vm.task.FieldTableMaxRows < vm.task.FieldTableMinRows) {
                    if (minmax === 'min')
                        vm.task.FieldTableMaxRows = vm.task.FieldTableMinRows;
                    else
                        vm.task.FieldTableMinRows = vm.task.FieldTableMaxRows;
                }
            },

            formatTime(time) {
                let h = Math.floor(time / 3600);
                let m = Math.floor((time - h * 3600) / 60);
                let s = Math.floor(time - h * 3600 - m * 60);

                return (h > 9 ? h : '0' + h) + ':' + (m > 9 ? m : '0' + m) + ':' + (s > 9 ? s : '0' + s);
            },

            onFileChange() {
                let vm = this;
                let files = document.getElementById('dropFiles').files;
                if(files.length > 0) {
                    if(window.FormData !== undefined) {
                        let data = new FormData();
                        for(let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }
                        vm.importResult = null;

                        this.callApiWrapper(backendApi.tasksImportSku(data)).then(function (response) {
                            document.getElementById('dropFiles').value = '';
                            if(response.hasError) {
                                UI.toastr.error('Ошибка импорта');
                            }
                            else {
                                if(response.data) {
                                    let counter = Object.entries(vm.dialogSkuList).length + 1;
                                    for(let s of response.data) {
                                        let newItemKey = s.SkuId.toString();
                                        if(!vm.dialogSkuList[newItemKey]) {
                                            vm.$set(vm.dialogSkuList, newItemKey, {id: s.SkuId, name: s.SkuName, active: s.Active, bonus: s.Bonus, order: counter});
                                            counter = counter + 1;
                                        } else {
                                            vm.dialogSkuList[newItemKey].active = s.Active;
                                            vm.dialogSkuList[newItemKey].bonus = s.Bonus;
                                        }
                                    }
                                }
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

            copyTasksSettingsModal() {
                let vm = this;
                vm.taskCopy = {
                    Id: vm.task.Id,
                    Name: vm.task.Name,
                    Caption: vm.task.Caption,
                    StartDateFormatted: vm.task.StartDateFormatted,
                    EndDateFormatted: vm.task.EndDateFormatted,
                    StartDate: vm.task.StartDate,
                    EndDate: vm.task.EndDate
                };
                vm.onShowModal('ppCopyTasksSettings');
            },

            copyTasks() {
                let vm = this;

                Promise.all([
                    vm.$validator.validate('CopySettingsName'),
                    vm.$validator.validate('CopySettingsDescription'),
                    vm.$validator.validate('CopyStartDateFormatted'),
                    vm.$validator.validate('CopyEndDateFormatted')
                ]).then(result => {
                    if(!result.every(Boolean)) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        if(vm.taskCopy.StartDate > vm.taskCopy.EndDate) {
                            UI.toastr.error('Дата окончания не может быть раньше даты начала');
                            return;
                        }

                        UI.blockUI('.dataContent', 'Сохранение...');

                        let saveObj = Object.assign({}, vm.taskCopy, {});
                        saveObj.FieldSettings = vm.fieldSettingsStr;


                        saveObj.MemberFilterUsers = vm.memberFilterUsersStr;
                        saveObj.MemberFilterValue = vm.memberFilterValueStr;
                        if(!saveObj.MemberFilterActivation) {
                            saveObj.MemberFilterVariant = null;
                        }

                        backendApi.tasksCopy(saveObj).then(function (response) {
                            UI.unblockUI('.dataContent');
                            if(response.hasError) {
                                UI.toastr.error('Ошибка при дублировании задания');
                            } else {
                                UI.toastr.success('Успешно сохранено');
                                vm.$refs.ppCopyTasksSettings.close();
                                console.info('copyTasks', response, vm.task.ProjectId);
                                vm.$router.push('/tasks/edit/' + vm.task.ProjectId + '/' + response.data);
                            }
                        });
                    }
                });
            },

            changedFilterActivation() {
                this.changedFilterField();
            },

            changedFilterVariant() {
                let vm = this;
                if(vm.task) {
                    switch(vm.task.MemberFilterVariant) {
                        case vm.MemberFilters.Users:
                        case vm.MemberFilters.TradePoints:
                            vm.task.MemberFilterField = null;
                            break;
                        case vm.MemberFilters.Roles:
                            vm.task.MemberFilterField = {Roles: [], Grades: []};
                            break;
                    }
                }
                this.changedFilterField();
            },

            onCheckedDownScroll(isSelectAll) {
                let vm = this;
                if(!vm.loading && vm.canBeLoadedCheckedDown) {
                    vm.pageCheckedDown++;
                    vm.loadMemberFilter(isSelectAll);
                }
            },

            changedFilterField() {
                this.memberFilterValue = [];
                this.pageCheckedDown = 1;
                this.canBeLoadedCheckedDown = true;
                this.loadMemberFilter(false);
            },

            changedMemberFilterRole() {
                let vm = this;
                vm.memberFilterGrades = [];
                var roles = vm.task.MemberFilterField.Roles.filter(x => x.LevelsInProject.length > 0);
                vm.useGradeOnSelectedRoles = roles.length > 0;
                if(roles.length > 0) {
                    for(let r = 0; r < roles.length; r++) {
                        for(let l = 0; l < roles[r].LevelsInProject.length; l++) {
                            vm.memberFilterGrades.push({
                                Value: roles[r].Value.toString() + '+' + roles[r].LevelsInProject[l].Id,
                                Name: roles[r].Name + '-' + roles[r].LevelsInProject[l].Name,
                                LevelId: roles[r].LevelsInProject[l].Id
                            });
                        }
                    }
                }
                vm.changedFilterToRoleUsers = true;
            },

            changedMemberFilterGrade() {
                this.changedFilterToRoleUsers = true;
            },

            memberFilterUsersLoad(searchText, callback, page, selectAll) {
                let vm = this;
                if(vm.changedFilterToRoleUsers || page > 1) {
                    let roleValues = JSON.stringify(_.map(vm.task.MemberFilterField.Roles, 'Value'));
                    let gradeValues = JSON.stringify(_.map(vm.task.MemberFilterField.Grades, 'Value'));
                    let rowsPerPage = 20;
                    let take = rowsPerPage;
                    if(selectAll)
                        take = 5000;
                    vm.changedFilterToRoleUsers = false;
                    //console.info('memberFilterUsersLoad', (page - 1) * rowsPerPage, take, searchText, roleValues, gradeValues);
                    vm.callApiWrapper(backendApi.tasksUsersOnRoles((page - 1) * rowsPerPage, take, vm.task.Id, searchText, roleValues, gradeValues))
                        .then(function (resp) {
                            callback(resp.data);
                        });
                }
                else {
                    callback(null);
                }
            }
        },

        mounted() {
            let vm = this;

            UI.blockUI('.dataContent', 'Загрузка...');

            Promise.all([this.loadSettings(), this.loadRoles()]).then(() => {
                this.loadTask().then(() => {
                    UI.unblockUI('.dataContent');

                    vm.loadMemberFilter(false);

                    vm.imgmixin_lightzoomInit();
                });
                //UI.unblockUI('.dataContent');

                $(document).on('change', '[name="dropFiles2"]', function () {
                    vm.onAttachFiles({ files: this.files });
                });

            });

            $(document).on('click', '.block-in-page-collapce', function () {
                UI.block_collapse(this);
            });
        },

        destroyed(){
            $(document).off('change', '[name="dropFiles2"]');
            $(document).off('click', '.block-in-page-collapce');
        }
    }
</script>

<style scoped>
    .block-in-page.opened .block-in-page-detail {
        overflow:visible;
    }

    .fancybox-inner {
        overflow: hidden !important;
    }

    .fancybox-nav {
        width: 40px !important;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/TasksEdit.vue